import { addressSystemLogos } from '@/constants';
import { getAddressSystem } from '@sonarwatch/portfolio-core';

export function getAddressSystemLogo(address: string): string | undefined {
  const addressSystem = getAddressSystem(address);
  if (!addressSystem) return undefined;
  return addressSystemLogos[addressSystem];
}
